<template>
    <div class="panelTitle" :data-icoTarget="icoTarget">
        <div>
            {{ name }}
            <i v-if="subName">{{ subName }}</i>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        name: 'ui-Title',
        data: function() {
            return {};
        },
        props: {
            name: String,
            subName: String,
            icoTarget: String,
        },
        methods: {},
        computed: {},
    };
</script>
